import { render, staticRenderFns } from "./ProjectVersionActionsDuplicate.vue?vue&type=template&id=0577974f&lang=pug&"
import script from "./ProjectVersionActionsDuplicate.vue?vue&type=script&lang=js&"
export * from "./ProjectVersionActionsDuplicate.vue?vue&type=script&lang=js&"
import style0 from "./ProjectVersionActionsDuplicate.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports